import { BooleanInput } from '@angular/cdk/coercion';
import {
  Component,
  ViewEncapsulation,
  booleanAttribute,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import {
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { isRequired } from '../../utilities/form-control.util';

@Component({
  selector: 'procure-input-search',
  templateUrl: './input-search.component.html',
  styleUrl: './input-search.component.scss',
  imports: [
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    MatIcon,
    MatIconButton,
    MatLabel,
    MatSuffix,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class InputSearch {
  readonly id = input<string | null>(null);
  readonly control = input.required<FormControl>();
  readonly label = input<string>('');
  readonly type = input<string>('text');
  readonly icon = input<string>('search');
  readonly placeholder = input<string>('');

  readonly showMode = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly condensed = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly clearable = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly trigger = output<string>();

  protected get controlPlaceholder(): string {
    if (this.control()?.disabled) {
      return '';
    }

    return this.placeholder();
  }

  protected get isRequired(): boolean {
    return isRequired(this.control());
  }

  protected get value(): string {
    const { value } = this.control();
    return value || '-';
  }

  protected get showClear(): boolean {
    const control = this.control();

    return this.clearable() && control.enabled && !!control.value;
  }

  onSearch(): void {
    this.trigger.emit(this.value);
  }

  clear(): void {
    this.control().setValue('');
    this.onSearch();
  }
}
